import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssessmentGroup } from "../../shared/models/assessment-group";
import { ManagedClient } from '../../shared/models/managed-client';
import { ClientService } from '../../shared/services/client.service';
import { Assessment } from "../../shared/models/assessment";
import { Location } from "@angular/common";
import { DacConfig } from "../../shared/services/dac-config.service";
import { AssessmentTokenService } from "../../shared/services/assessment-token.service";
import { ReportService } from "../../reports/services/report.service";

import { User } from 'app/shared/models/user';
import { AlertService } from 'app/shared/services/alert.service';
import { TabsetComponent } from 'ng-mdb-pro/pro';
import { Assignment } from 'app/shared/models/Assignment';
import { AssignedAssessment } from 'app/shared/models/AssignedAssessment';
import { AssignedAssessmentGroup } from 'app/shared/models/AssignedAssessmentGroup';
import { ShoppingService } from 'app/shared/services/shopping.service';
import { AssessmentAssignerService } from '../services/assessment-assigner.service';
import { AuthService } from 'app/login/services/auth.service';
import { AssignmentService } from 'app/shared/services/assignment.service';
import { AssignedLibraryAsset } from 'app/shared/models/AssignedLibraryAsset';
import { AssignmentSingle } from 'app/shared/models/AssignmentSingle';
import { LibraryAsset } from 'app/library-assets/models/library-asset';

//import 'rxjs/add/operator/switchMap';

//import { Assessment } from '../models/assessment';

interface ReportResult {
  id: string;
  name: string;
  hasMetRequirements: boolean;
}
interface ReportResultContainer {
  [name: string] : ReportResult[]
}

@Component({
  selector: 'app-client-edit',
  templateUrl: './client-edit.component.html',
  styleUrls: ['./client-edit.component.css']
})
export class ClientEditComponent implements OnInit {

  @ViewChild('staticTabs') staticTabs: TabsetComponent;

  private _client: ManagedClient;
  private _clientToSave: ManagedClient;
  private _newAssignedUser: User;
  private _reportsByAssignment:ReportResultContainer;
  public loadedClient:boolean;
  public isSavingClient:boolean;
  public clientShareLink:string;
  public hasActiveSubscription:boolean;

  constructor(
    private _clientService: ClientService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private reportService:ReportService,
    private authService:AuthService,
    private shoppingService:ShoppingService,
    private assessmentAssignerService:AssessmentAssignerService,
    private assignmentService:AssignmentService
  ) {
    this._reportsByAssignment = {};
    this._client = new ManagedClient();
    this._clientToSave = new ManagedClient();
    this.loadedClient = false;
    this.clientShareLink = window.location.href;
    this.hasActiveSubscription = false;
  }

  ngOnInit() {
    this.authService.getLoginState().subscribe(loginState => {
      if (loginState && loginState.user) {
        this.hasActiveSubscription= loginState.user.hasActiveSubscription();
      }
      else {
        this.hasActiveSubscription = false;
      }
    });

    // we are skipping the whole switchMap thingy until we figure out
    // more on how to use it... for now we are just trying to port the code
    // from angularjs (1.X)
    // TODO: stephen figure out how to do the switchMap to cut down on multiple http requests.
    this.route.params.subscribe(params => {
      let clientId = params['id'];
      if (!clientId || typeof clientId !== "string") {
        this.router.navigate(['../']);
        return;
      }

      this._clientService.getClient(clientId)
        .then((client: ManagedClient) => {
          console.log("loaded client is ", client);
          this._client = client;
          this._clientToSave = Object.assign(new ManagedClient(), client); // copy over relevant data
          this.loadedClient = true;
          // if we have no assignments we need to make sure we go to the tab for setting assignments.

          this._reportsByAssignment = {};
          // TODO: stephen I'm not sure I like the way this is implemented.
          return Promise.all(client.assignments.map(a => this.reportService.getReportsForAssignment(a).then(reports => {
            this._reportsByAssignment[a.Id] = reports.map(r => Object.assign(r, {IsComplete: a.IsComplete, hasMetRequirements: true}));
          })))
          .then((results) => {
            return client;
          })
        })
        .then((client) => {
          // since the tabs haven't rendered yet... we need to wait for them to render now that the
          // client has loaded.
          if (client.hasNoAssignments()) {
            setTimeout(() => {
             if (this.staticTabs) {
                this.staticTabs.tabs[1].active=true;
              }
            }, 250);
          }
        })
        .catch((error) => {
          this.alertService.error("Failed to load client from server. Please check your internet connection and reload the page");
          console.error(error);
          // TODO: stephen handle when client is not
          // found
        });
      
    });

  }


  goBack() {
    this.location.back();
  }
  public get assignments(): Assignment[] {
    return this._client.assignments;
  }

  public getReportsForAssignment(assignment:Assignment) {
    if (this._reportsByAssignment[assignment.Id]) {
      return this._reportsByAssignment[assignment.Id];
    }
    return [];
  }

  public setNewUser(user:User) {
    this._newAssignedUser = user;
  }

  public updateClientUser(isValid:boolean) {

    if (!isValid) {
      this.alertService.error("You must fill in all required fields");
      return;
    }
    
    // need to go through and validate the client
    if (this._newAssignedUser) {
      this._clientToSave.user = this._newAssignedUser;
    }
    // let errors = this._clientService.validateClient(this._clientToSave);

    this.isSavingClient = true;
    this._clientService.saveClient(this._clientToSave).then((result) => {
      this.isSavingClient = false;
      this._client.lastName = this._clientToSave.lastName;
      this._client.firstName = this._clientToSave.firstName;
      this._client.email = this._clientToSave.email;
      this._client.user = this._clientToSave.user;
      this.alertService.success("Client information was updated");
    })
    .catch((error) => {
      this.isSavingClient = false;
      this.alertService.error("Failed to update client information.  Try again or contact support");
      console.error(error);
    })
  }

  public get client(): ManagedClient {
    return this._client;
  }

  public set client(v: ManagedClient) {
    this._client = v;
  }

  public get clientToSave() : ManagedClient {
    return this._clientToSave;
  }
  public set clientToSave(v:ManagedClient) {
    this._clientToSave = v;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/client-edit/client-edit.component.ts